<!-- eslint-disable vue/no-v-html -->
<template>
	<section
		v-if="cfg"
		class="mmun-blue py-5">
		<div class="container text-white">
			<h2
				class="text-center bolder-text mb-5"
				v-html="title" />
			<div class="row g-4">
				<div
					v-for="(col, idx) in columns"
					:key="'mmun-blue-'+idx"
					class="col-lg-4">
					<div class="text-center h-100 d-flex flex-column align-items-center">
						<img
							v-if="col.image"
							:src="requireAsset(col.image)"
							alt=""
							class="img-fluid mb-3 mmun-blue__img">
						<h5
							class="bolder-text mmun-blue__subtitle mb-3"
							v-html="col.title" />
						<ul class="list-unstyled text-start">
							<li
								v-for="(b, i) in col.bullets"
								:key="'mmun-blue-'+idx+'-b-'+i"
								class="d-flex align-items-start mb-2">
								<span
									class="me-2 d-inline-flex align-items-center justify-content-center"
									aria-hidden="true">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="18"
										height="18"
										viewBox="0 0 20 20">
										<path
											d="M10,20A10,10,0,1,0,0,10,10,10,0,0,0,10,20ZM14.414,8.164l-5,5a.934.934,0,0,1-1.324,0l-2.5-2.5A.936.936,0,0,1,6.914,9.34L8.75,11.176l4.336-4.34A.936.936,0,0,1,14.41,8.16Z"
											:fill="primaryColor" />
									</svg>
								</span>&nbsp;
								<span v-html="b" />
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import { JnsLandingPages } from '@/translations';
import { PRODUCT_PAGES } from '@/settings/JnsLandingPages';
import Page from '@/views/JnsLandingPages/mixins/Page';
import Storage from '@/views/JnsLandingPages/mixins/Storage';
import Replacements from '@/views/JnsLandingPages/mixins/Replacements';

export default {
	name: 'MmunBlueBenefits',
	messages: [JnsLandingPages],
	mixins: [Page, Storage, Replacements],
	data() {
		return { primaryColor: '#390776' };
	},
	computed: {
		cfg() { return PRODUCT_PAGES[this.pageName]?.mmunBlueSection || null; },
		title() { return this.applyReplacements(this.translate(this.cfg?.title || '')); },
		columns() {
			const cols = this.cfg?.columns || [];
			return cols.map((c) => ({
				image: c.image || '',
				title: this.applyReplacements(this.translate(c.title || '')),
				bullets: (c.bullets || []).map((k) => this.applyReplacements(this.translate(k))).filter(Boolean),
			}));
		},
	},
	mounted() {
		try {
			const c = getComputedStyle(this.$el).getPropertyValue('--jlp-primary-color').trim();
			if (c) this.primaryColor = c;
		} catch (e) { /* noop */ }
	},
};
</script>

<style scoped>
.mmun-blue { background: #19a6df; }
.mmun-blue__img { max-height: 140px; object-fit: contain; }
.mmun-blue__subtitle { color: var(--jlp-primary-color, #390776); }
.bolder-text { font-weight: bolder; }
li { font-weight: bold; }
</style>
